export default "__VITE_ASSET__dshchFp2__"